import React, { useMemo } from "react";
import { Text } from "@salestrak/ui";
import type { ActivityChange } from "../activity-types";
import { formatDate } from "../activity-utils";

interface DateChunkProps {
  change: ActivityChange;
}

export function DateChunk({ change }: DateChunkProps) {
  const fullText = useMemo(() => {
    const actionText = (() => {
      switch (change.action) {
        case "created":
          return "set";
        case "deleted":
          return "cleared";
        case "updated":
          return "updated";
        default:
          return change.action;
      }
    })();

    const targetText = (() => {
      switch (change.target.type) {
        case "startDate":
          return "start date";
        case "targetDate":
          return "target date";
        default:
          return change.target.type;
      }
    })();

    let beforeText = "";
    if (change.action === "updated" && change.oldValue?.value) {
      beforeText = `from ${formatDate(change.oldValue.value)}`;
    }

    let afterText = "";
    if (change.action !== "deleted" && change.newValue?.value) {
      afterText = `to ${formatDate(change.newValue.value)}`;
    }

    const resultText =
      beforeText && afterText
        ? `${beforeText} ${afterText}`
        : !beforeText && afterText
          ? afterText
          : "";

    return `${actionText} ${targetText}${resultText ? ` ${resultText}` : ""}`;
  }, [change]);

  return <Text size="sm">{fullText}</Text>;
}
